export const AWAITING_THEME_LIST = "awaiting-theme-list";

export type CreatedThemeSnapshot =
  | ReadonlySet<string>
  | typeof AWAITING_THEME_LIST
  | null;

export const snapshotThemeIds = (
  themes: readonly { _id: string }[] | undefined,
): CreatedThemeSnapshot =>
  themes ? new Set(themes.map((t) => t._id)) : AWAITING_THEME_LIST;

export const findCreatedThemeId = (
  knownIds: ReadonlySet<string>,
  themes: readonly { _id: string }[],
): string | null => themes.find((t) => !knownIds.has(t._id))?._id ?? null;

// When Create new was clicked before the list loaded, the first loaded list is
// the baseline: it arrives long before the user can finish and save a theme.
export const resolveCreatedTheme = (
  snapshot: CreatedThemeSnapshot,
  themes: readonly { _id: string }[] | undefined,
): { snapshot: CreatedThemeSnapshot; createdId: string | null } => {
  if (!snapshot || !themes) return { snapshot, createdId: null };
  if (snapshot === AWAITING_THEME_LIST)
    return { snapshot: snapshotThemeIds(themes), createdId: null };
  const createdId = findCreatedThemeId(snapshot, themes);
  return { snapshot: createdId ? null : snapshot, createdId };
};
